import { AgreementBUInterface, BusinessUnitInterface } from '../interfaces'

export const AGREEMENT_BU_ACTIVE_STATUS = 1

// Filtra AgreementBU usables (isSource, !isLocked, statusID activo) y las mapea
// a la BusinessUnit completa por buCode, deduplicando por buid. Pura/testeable.
export const resolveOriginBusinessUnits = (
  agreementBUs: AgreementBUInterface[],
  businessUnits: BusinessUnitInterface[]
): BusinessUnitInterface[] => {
  const usable = agreementBUs.filter(
    (a) =>
      a.isSource &&
      !a.isLocked &&
      (a.statusID === AGREEMENT_BU_ACTIVE_STATUS || a.statusID == null)
  )

  const resolved: BusinessUnitInterface[] = []
  const seen = new Set<number>()

  usable.forEach((a) => {
    const bu = businessUnits.find((b) => b.buCode === a.buCode)
    if (!bu) {
      console.warn(`AgreementBU buCode sin match en catálogo: ${a.buCode}`)
      return
    }
    if (seen.has(bu.buid)) return
    seen.add(bu.buid)
    resolved.push(bu)
  })

  return resolved
}
